import React from 'react';
import { cn } from '@express-labs/raven-tools';

import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Circle: React.FC<IconV1Props> = ({ icon, fill }) => (
  <svg
    className={cn(s.svg, 'svg-icon--circle')}
    viewBox="0 0 200 200"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
    fill={fill}
  >
    <circle cx="100" cy="100" r="100" />
  </svg>
);

export default Circle;
